import * as THREE from 'three'
import { FACES, COLORS } from '../Global/materials';

// Conversion factor from degrees to radians
const toRad = Math.PI / 180;

// CompassRing extends THREE.Object3D to build a visual compass UI element
export default class CompassRing extends THREE.Object3D {
    constructor() {
        super();
        this._build(); // Initialize and build the compass components
    }

    // Constructs the ring and directional arrows
    _build() {
        const ringGeo = new THREE.RingGeometry(22, 23); // Thin circular ring
        const ringMat = new THREE.MeshBasicMaterial({ color: COLORS.white }); // White ring material
        const ring = new THREE.Mesh(ringGeo, ringMat); // Mesh for the compass ring
        this.add(ring); // Add ring to the compass object
        
        const arrows = this._createArrows(); // Create directional arrows
        this.add(arrows); // Add arrows to the compass object
    }

    // Creates all four directional arrows (N, S, E, W)
    _createArrows() {
        const arrows = new THREE.Object3D(); // Group to hold all arrows

        // Add arrows for each direction with respective positions and rotations
        arrows.add(this._createArrow(0xffffff, 0xe2e2e2, FACES.east, [-23, 0, 0], 0));   // Actually points west
        arrows.add(this._createArrow(0xffffff, 0xe2e2e2, FACES.west, [23, 0, 0], 180));  // Actually points east
        arrows.add(this._createArrow(0xffffff, 0xe2e2e2, FACES.north, [0, -23, 0], 90)); // Actually points south
        arrows.add(this._createArrow(0xf64f4f, 0xd64f4f, FACES.south, [0, 23, 0], -90)); // Actually points north (highlighted in red)
        
        return arrows;
    }

    // Creates a single directional arrow with shape, color, and rotation
    _createArrow(color, hover, name, position, angle) {
        const shape = new THREE.Shape();
        shape.moveTo(-5, 0);
        shape.lineTo(6, 4);
        shape.lineTo(4, 0);
        shape.lineTo(6, -4);

        const geo = new THREE.ShapeGeometry(shape); // Convert shape into geometry
        const mat = new THREE.MeshBasicMaterial({ color: color }); // Material with base color
        const arrow = new THREE.Mesh(geo, mat); // Create mesh from shape and material

        arrow.name = name; // Assign face name (FACES.north, etc.)
        arrow.userData.color = color; // Store default color for resetting
        arrow.userData.hover = hover; // Store hover color
        arrow.position.set(...position); // Position arrow on the ring
        arrow.rotateZ(angle * toRad); // Rotate arrow to face correct direction

        return arrow; // Return the constructed arrow mesh
    }
}
